import React from "react";

/**
 * 다중 선택 체크박스 — 종합보고서 종류·필터 등
 */
export function DetailOptionChips({options = [], onChange, className = ""}) {
    if (!Array.isArray(options) || options.length === 0) {
        return null;
    }

    return (
        <div className={`detail-option-chips ${className}`.trim()} role="group">
            {options.map((option) => {
                const selected = !!option.checked;
                const key = option.id ?? option.value ?? option.name;
                const label = option.name ?? option.label;

                return (
                    <label
                        key={key}
                        className={`detail-option-chip${selected ? " is-selected" : ""}`}
                    >
                        <input
                            type="checkbox"
                            className="detail-option-chip__input"
                            checked={selected}
                            onChange={() => onChange?.(option, !selected)}
                        />
                        <span className="detail-option-chip__label">{label}</span>
                    </label>
                );
            })}
        </div>
    );
}
